import { FC } from 'react';
import * as R from 'ramda';
import { Connection, Handle, NodeProps, Position } from 'react-flow-renderer';
import Node, { contentStyle, contentStyle as style } from './Node';
import { Badge, Box, Tooltip, Typography } from '@mui/material';

const isValidInput = (connection: Connection) => {
  return R.last(R.split('__', connection.targetHandle as string)) === R.last(R.split('__', connection.sourceHandle as string));
};
const isValidOutput = (connection: Connection) => {
  return (R.split('_', connection.target as string)[0] === 'campanhaOnl'
    || R.split('_', connection.target as string)[0] === 'sleep');
};

export const CondicionalNode: FC<NodeProps> = ({ data, selected, }) => {
  const listOutput: string[] = data.condicionalOutput ? data.condicionalOutput.split(',') : [];

  return (
    <Badge badgeContent={data.erros | 0} color="error">

      <Node
        label='Condicional'
        icon='question_mark'
        selected={selected}
        color={'#F2CE16'}
        content={
          <>
            {data.condicionalInput && (
              <Box style={style.io}>
                <Handle
                  type='target'
                  position={Position.Left}
                  id={`i-cnd__${data.condicionalInput}`}
                  style={{ ...style.handle, ...style.left }}
                  isValidConnection={isValidInput}
                />
                {data.condicionalInput}
              </Box>
            )}

            {data.condicionalOutput && (<>
              <Box style={contentStyle.contentHeader}>{data.label}</Box>

              {listOutput.map((out, index) => (
                <Box
                  key={`o-${out}-${index}`}
                  style={{ ...style.io, ...style.textRight }}
                >
                  {out}
                  {data.textoCondicionalRetorno && (
                    <Tooltip title={data.textoCondicionalRetorno[index]} followCursor>
                      <Typography style={{ fontSize: '10px', }} noWrap>
                        {data.textoCondicionalRetorno[index]}
                      </Typography>
                    </Tooltip>
                  )}
                  <Handle
                    type='source'
                    position={Position.Right}
                    id={`o-cond__${out}-${index}`}
                    style={{ ...style.handle, ...style.right }}
                    isValidConnection={isValidOutput}
                  />
                </Box>
              ))}

            </>)}
          </>
        }
      />
    </Badge >
  );
};
